// import { getBuyerJWTToken } from '@common/utils/token';

import Carousel from '@brainhubeu/react-carousel';
import useBuyerLogin from '@common/hooks/useBuyerLogin';
import Review from '@common/models/Review';
import { fetchNextPageProductReviewsRequest } from '@common/store/productDetails/slice';
import { isBrowser } from '@common/utils';
import { isMobile } from '@common/utils';
import { getBuyerJWTToken } from '@common/utils/token';
import ArrowRight from '@images/ArrowRight.svg';
import Link from '@lib/Link';
import React, { useCallback, useRef } from 'react';
import { connect } from 'react-redux';

// import { ReactComponent as StarIcon } from '@common/icons/Star.svg';
// import Ratingbar from './Ratingbar';
// import StarRating from './StarRating';
import ReviewComponent from './Review';

// import Carousel from '@brainhubeu/react-carousel';

export interface RatingProps {
  className?: string;
  reviews: Array<Review>;
  productSlug?: string;
  nextReviewsUrl: string | null;
  reviewsCount: number;
  fetchNextPageProductReviewsRequest: typeof fetchNextPageProductReviewsRequest;
  isNextReviewsLoadingFailed: boolean;
  isNextReviewsLoading: boolean;
}

const Rating: React.FunctionComponent<RatingProps> = ({
  className = '',
  reviews = [],
  productSlug,
  fetchNextPageProductReviewsRequest,
  nextReviewsUrl,
}) => {
  const { features, hideReviewsSection } = useBuyerLogin();
  const observer = useRef<IntersectionObserver | null>();

  if (hideReviewsSection) {
    return null;
  }

  const lastElementRef = useCallback(
    (node) => {
      if (isBrowser()) {
        if (observer?.current) observer?.current.disconnect();
        observer.current = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            if (nextReviewsUrl)
              fetchNextPageProductReviewsRequest({ nextReviewsUrlPageNo: nextReviewsUrl, productSlug: productSlug });
          }
        });
        if (node) observer.current.observe(node);
      }
    },
    [nextReviewsUrl],
  );
  return (
    <div id="Review" className={className} color-customisation="page-bg">
      <div
        className="text-heading text-center text-24 md:text-32 font-semibold md:leading-loose mx-auto mb-32"
        font-customisation="section-heading"
        color-customisation="page-heading"
      >
        Customer Reviews
      </div>
      <Carousel
        slidesPerPage={isMobile() ? 1.1 : 3}
        showArrows={true}
        addArrowClickHandler={true}
        arrowLeftDisabled={<></>}
        arrowRightDisabled={<></>}
        arrowLeft={
          <div className="hidden md:block absolute h-32 w-32 cursor-pointer">
            <img src={ArrowRight} alt="Left" className="absolute transform rotate-180 h-full w-full z-999" />
          </div>
        }
        arrowRight={
          <div className="hidden md:block absolute h-32 w-32 cursor-pointer">
            <img src={ArrowRight} alt="Right" className="object-contain h-full w-full z-999" />
          </div>
        }
      >
        {[
          ...reviews.map((review, index) => (
            <div
              className="w-full pr-10 flex-col h-full"
              ref={index === reviews.length - 1 ? lastElementRef : null}
              key={review.id}
            >
              <ReviewComponent
                key={review.id}
                name={review.customerName}
                date={review.created}
                review={review.review}
                rating={review.rating}
              />
            </div>
          )),
          // (isNextReviewsLoading || nextReviewsUrl) && !isNextReviewsLoadingFailed && (
          //   <>
          //     <div className="w-full pr-10 flex-col h-full">
          //       <LoaderIcon size={35} />
          //     </div>
          //   </>
          // ),
        ]}
      </Carousel>
      {features?.features?.buyerLogin && (
        <Link
          to={
            getBuyerJWTToken()
              ? `/product/${productSlug}/review`
              : `/account/login?redirect_url=/product/${productSlug}/review`
          }
          className="mt-48 block text-center"
        >
          <button
            type="submit"
            className="w-160 h-48 border border-heading text-heading mx-auto"
            font-customisation="para-text"
          >
            Write a Review
          </button>
        </Link>
      )}
    </div>
  );
};

export default connect(null, { fetchNextPageProductReviewsRequest })(Rating);
